export default {
  sendSystemInvitation(id) {
    return axios.post(`${ import.meta.env.VITE_SITE_URL }/crms/${ id }/mail/system-invitation`);
  },
};
